import {
  CardImageProps,
  PillProps,
  PricingData,
  ReviewSummary,
} from '../../common/types';
import { Range } from 'react-input-range';

export interface FilterListPayload extends Currency {
  cards: CardPropsPayload[];
  translations: Translations;
  filters: FilterConfig[];
  id: string;
}

interface Currency {
  currency: string;
}

interface FilterConfig extends BaseOption {
  type: number;
  icon?: string;
  options: BaseOption[];
}

export interface BaseOption {
  id: number;
  name: string;
}

export interface ActiveFilterStates {
  price: Range;
  selectedFilters: number[];
}

export interface CardListFilterState {
  cards: CardProps[];
  showAllCards: boolean;
  selectedCards: number[];
  activeFilters?: ActiveFilterStates;
  translations: Translations;
  isLoading: boolean;
  isProcessing: boolean;
  filters: (MultiOptionCategory | RangeFilterCategory)[];
  isFilterVisibleOnSmall: boolean;
  sectionId?: string;
  openCardsInNewTab: boolean;
}

export enum FilterTypes {
  Undefined = 0,
  Price = 1,
  Month = 2,
  Checkbox = 3,
}

interface BaseCardProps {
  id: number;
  url: string;
  image?: CardImageProps;
  promoPill: PillProps;
  primaryPill: PillProps;
  secondaryPill: PillProps;
  type: string;
  title: string;
  description: string;
  reviews: ReviewSummary;
  reviewsElfsightWidgetId?: string;
  params: number[];
  externalIDs: string | string[] | null | undefined;
}

export interface CardProps extends BaseCardProps {
  priceData?: CardPricing;
  openInNewTab?: boolean;
}

export interface CardPropsPayload extends BaseCardProps {
  priceData: PricingData;
}

export interface CardPricing extends PricingData, Currency {}

export interface Translations {
  now: string;
  viewTour: string;
  less: string;
  more: string;
  clear: string;
  close: string;
  apply: string;
}

export interface FilterCategory {
  id: number;
  type: number;
  name: string;
  icon?: string;
  closed: boolean;
  showAll: boolean;
}

export interface RangePayload extends Range {
  index: number;
}

export interface RangeFilterCategory extends FilterCategory, Range {
  activeMin: number;
  activeMax: number;
}

export interface MultiOptionCategory extends FilterCategory {
  options: FilterOption[];
}

export interface FilterOption extends BaseOption {
  selected: boolean;
  disabled: boolean;
  count?: number;
}

export interface CategoryFilterSelection {
  categoryIndex: number;
  optionIndex: number;
}

export interface PriceUpdate extends RangePayload {
  activeCards: number[];
  changes: CategoryChanges;
}

export interface CategoryChanges {
  index: number;
}

export interface OptionChanges {
  index: number;
  selected: boolean;
  disabled: boolean;
  count?: number;
}
